import {
  FETCH_DRIVER_REMARKS,
  FETCH_DRIVER_REMARKS_SUCCESS,
  FETCH_DRIVER_REMARKS_FAILED,
  FETCH_ALL_DRIVER_REMARKS,
  FETCH_ALL_DRIVER_REMARKS_SUCCESS,
  FETCH_ALL_DRIVER_REMARKS_FAILED,
  ADD_DRIVER_REMARK,
  EDIT_DRIVER_REMARK,
  DELETE_DRIVER_REMARK,
  CLEAR_DRIVER_REMARKS_ERROR,
} from "../store/types";

const INITIAL_STATE = {
  remarks: [],
  allRemarks: [],
  loading: false,
  allRemarksLoading: false,
  error: null,
  allRemarksError: null,
  addLoading: false,
  addError: null,
  editLoading: false,
  editError: null,
  deleteLoading: false,
  deleteError: null,
};

export const driverremarksreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_DRIVER_REMARKS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_DRIVER_REMARKS_SUCCESS:
      return {
        ...state,
        remarks: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_DRIVER_REMARKS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_ALL_DRIVER_REMARKS:
      return {
        ...state,
        allRemarksLoading: true,
        allRemarksError: null,
      };
    case FETCH_ALL_DRIVER_REMARKS_SUCCESS:
      return {
        ...state,
        allRemarks: action.payload,
        allRemarksLoading: false,
        allRemarksError: null,
      };
    case FETCH_ALL_DRIVER_REMARKS_FAILED:
      return {
        ...state,
        allRemarksLoading: false,
        allRemarksError: action.payload,
      };
    case ADD_DRIVER_REMARK:
      if (action.payload.loading) {
        return {
          ...state,
          addLoading: true,
          addError: null,
        };
      } else if (action.payload.success) {
        return {
          ...state,
          addLoading: false,
          addError: null,
        };
      } else if (action.payload.error) {
        return {
          ...state,
          addLoading: false,
          addError: action.payload.error,
        };
      }
      return state;
    case EDIT_DRIVER_REMARK:
      if (action.payload.loading) {
        return {
          ...state,
          editLoading: true,
          editError: null,
        };
      } else if (action.payload.success) {
        return {
          ...state,
          editLoading: false,
          editError: null,
        };
      } else if (action.payload.error) {
        return {
          ...state,
          editLoading: false,
          editError: action.payload.error,
        };
      }
      return state;
    case DELETE_DRIVER_REMARK:
      if (action.payload.loading) {
        return {
          ...state,
          deleteLoading: true,
          deleteError: null,
        };
      } else if (action.payload.success) {
        return {
          ...state,
          deleteLoading: false,
          deleteError: null,
        };
      } else if (action.payload.error) {
        return {
          ...state,
          deleteLoading: false,
          deleteError: action.payload.error,
        };
      }
      return state;
    case CLEAR_DRIVER_REMARKS_ERROR:
      return {
        ...state,
        error: null,
        addError: null,
        editError: null,
        deleteError: null,
      };
    default:
      return state;
  }
};
